interface Province {
    name: string,
    code: string,
    subdivision: string,
    native: string,
}

export const Provinces:Province[] = [
    {
		"name": "Guangxi",
		"code": "CN-45",
		"subdivision": "Autonomous region",
		"native": "广西"
	},
	{
		"name": "Nei Mongol",
		"code": "CN-15",
		"subdivision": "Autonomous region",
		"native": "内蒙古"
	},
	{
		"name": "Ningxia",
		"code": "CN-64",
		"subdivision": "Autonomous region",
		"native": "宁夏"
	},
	{
		"name": "Xinjiang",
		"code": "CN-65",
		"subdivision": "Autonomous region",
		"native": "新疆"
	},
	{
		"name": "Xizang",
		"code": "CN-54",
		"subdivision": "Autonomous region",
		"native": "西藏"
	},
	{
		"name": "Beijing",
		"code": "CN-11",
		"subdivision": "Municipality",
		"native": "北京"
	},
	{
		"name": "Chongqing",
		"code": "CN-50",
		"subdivision": "Municipality",
		"native": "重庆"
	},
	{
		"name": "Shanghai",
		"code": "CN-31",
		"subdivision": "Municipality",
		"native": "上海"
	},
	{
		"name": "Tianjin",
		"code": "CN-12",
		"subdivision": "Municipality",
		"native": "天津"
	},
	{
		"name": "Anhui",
		"code": "CN-34",
		"subdivision": "Province",
		"native": "安徽"
	},
	{
		"name": "Fujian",
		"code": "CN-35",
		"subdivision": "Province",
		"native": "福建"
	},
	{
		"name": "Gansu",
		"code": "CN-62",
		"subdivision": "Province",
		"native": "甘肃"
	},
	{
		"name": "Guangdong",
		"code": "CN-44",
		"subdivision": "Province",
		"native": "广东"
	},
	{
		"name": "Guizhou",
		"code": "CN-52",
		"subdivision": "Province",
		"native": "贵州"
	},
	{
		"name": "Hainan",
		"code": "CN-46",
		"subdivision": "Province",
		"native": "海南"
	},
	{
		"name": "Hebei",
		"code": "CN-13",
		"subdivision": "Province",
		"native": "河北"
	},
	{
		"name": "Heilongjiang",
		"code": "CN-23",
		"subdivision": "Province",
		"native": "黑龙江"
	},
	{
		"name": "Henan",
		"code": "CN-41",
		"subdivision": "Province",
		"native": "河南"
	},
	{
		"name": "Hubei",
		"code": "CN-42",
		"subdivision": "Province",
		"native": "湖北"
	},
	{
		"name": "Hunan",
		"code": "CN-43",
		"subdivision": "Province",
		"native": "湖南"
	},
	{
		"name": "Jiangsu",
		"code": "CN-32",
		"subdivision": "Province",
		"native": "江苏"
	},
	{
		"name": "Jiangxi",
		"code": "CN-36",
		"subdivision": "Province",
		"native": "江西"
	},
	{
		"name": "Jilin",
		"code": "CN-22",
		"subdivision": "Province",
		"native": "吉林"
	},
	{
		"name": "Liaoning",
		"code": "CN-21",
		"subdivision": "Province",
		"native": "辽宁"
	},
	{
		"name": "Qinghai",
		"code": "CN-63",
		"subdivision": "Province",
		"native": "青海"
	},
	{
		"name": "Shaanxi",
		"code": "CN-61",
		"subdivision": "Province",
		"native": "陕西"
	},
	{
		"name": "Shandong",
		"code": "CN-37",
		"subdivision": "Province",
		"native": "山东"
	},
	{
		"name": "Shanxi",
		"code": "CN-14",
		"subdivision": "Province",
		"native": "山西"
	},
	{
		"name": "Sichuan",
		"code": "CN-51",
		"subdivision": "Province",
		"native": "四川"
	},
	{
		"name": "Taiwan",
		"code": "CN-71",
		"subdivision": "Province",
		"native": "台湾"
	},
	{
		"name": "Yunnan",
		"code": "CN-53",
		"subdivision": "Province",
		"native": "云南"
	},
	{
		"name": "Zhejiang",
		"code": "CN-33",
		"subdivision": "Province",
		"native": "浙江"
	},
	{
		"name": "Hong Kong",
		"code": "CN-91",
		"subdivision": "Special administrative region",
		"native": "香港"
	},
	{
		"name": "Macao",
		"code": "CN-92",
		"subdivision": "Special administrative region",
		"native": "澳门"
	}
]